import React, { useState, useEffect } from "react";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import MembershipPlus from '../../components/membership-plus'
import NeedHelp from '../../components/need-help'

import { getSS, deleteSS, setSS } from '../../helpers'

const UpgradeForm: React.FC = (props: any) => {

  // console.log(props);

  interface upgradeOptionsProps {
    selected: string;
    to: string;
    price: string;
  }

  interface SelectedMembershipProps {
    [key: string]: any
  }

  const membership_form = (window as any).KEW.collections.membership_form[0]
  let types = JSON.parse(membership_form.membership_types).filter((item: any) => !item.with_donation);
  const [ upgradeOptions, setUpgradeOptions ] = useState<upgradeOptionsProps | undefined>(undefined)
  const [ selectedMembership, setSelectedMembership ] = useState<SelectedMembershipProps | undefined>(undefined)
  const [ topupDonation, setTopupDonation ] = useState<boolean>(getSS('sameTierTopupDonationAdded'))

  let membership = getSS('membership')

  const getMembershipTypeString = (
    membership: any,
    renewalDonationAdded: boolean,
    isTopupDonation: boolean
  ): string => {
    if (isTopupDonation) {
      return '';
    }

    if (renewalDonationAdded) {
      return ' membership plus donation';
    }

    if (!membership?.selected_membership?.value) {
      return ' membership';
    }

    return membership?.selected_membership?.value?.includes('plus')
      ? ' membership plus donation'
      : ' membership';
  };

  const membership_type = getMembershipTypeString(
    membership,
    props.values.renewal_donation_added,
    topupDonation
  );

  useEffect(() => {
    if (topupDonation) {
      showUpgradeNext(selectedMembership?.upgrade_from, selectedMembership?.title, 0, true)
      document.querySelector<HTMLButtonElement>('button.add')?.click()
    } else {
      document.querySelector<HTMLButtonElement>('button.link.remove')?.click()
    }
  // eslint-disable-next-line
  }, [selectedMembership, topupDonation])

  useEffect(() => {
    if (membership) {
      const selected = membership.selected_membership.upgrade_from
      const to = membership.selected_membership.title.replace(' membership plus donation', '')
      for (let i = 0; i < types.length; i++) {
          if (types[i].title === membership.selected_membership.upgrade_from) {
            let selected_membership = types[i]
            selected_membership.upgrade_from = selected
            setSelectedMembership(selected_membership)
          }
      }
      const price = membership.amount
      setUpgradeOptions({selected, to, price})
    }
    setTimeout(() => {
      if (getSS('sameTierTopupDonationAdded')) {
        (document.querySelector('.radios fieldset div label:first-of-type input') as HTMLElement | null)?.click()
      }
    }, 100);
    // eslint-disable-next-line
  }, [])

  function getSelectedMembership(type: any) {
    setUpgradeOptions(undefined)
    setTopupDonation(false)
    deleteSS('sameTierTopupDonationAdded')
    deleteSS('manualDonationAdded')
    props.setFieldValue('renewal_donation_added', 0)
    for (var i = 0; i < types.length; i++) {
      if (types[i].value === type) {
        let selected_membership = types[i];
        selected_membership.upgrade_from = types[i].title;
        setSelectedMembership(selected_membership)
      }
    }
  }

  function showUpgradeNext(selected: any, to: any, price: any, topup: any) {
    setTopupDonation(topup)
    if (topup) {
      setSS('sameTierTopupDonationAdded', topup)
    }
    setUpgradeOptions({selected, to, price})
  }

  function setSelectedMembershipModel(selectedMembership: any) {
    props.setFieldValue('payment_type', 'Single')
    props.setFieldValue('payment_method', 'Card/Paypal')
    // update selected membership to chosen upgrade
    for (var i = 0; i < types.length; i++) {
      if (types[i].title === upgradeOptions?.to.replace(' membership plus donation', '')) {
        let selected_membership_upgrades = selectedMembership.upgrades
        let selected_membership = types[i];
        if (props.values.renewal_donation_added) {
          selected_membership.value = selected_membership.value + 'plus'
          selected_membership.title = selected_membership.title + ' membership plus donation'
        }
        selected_membership.upgrades = selected_membership_upgrades
        selected_membership.upgrade_from = upgradeOptions?.selected
        props.setFieldValue('amount', upgradeOptions?.price + props.values.renewal_donation_added)
        props.setFieldValue('selected_membership', selected_membership)
        props.submitForm()
      }
    }
  }
console.log(upgradeOptions)
  return (
    <>
      <div className="row">
        <div className="upgrade-form clearfix box">
          <div className="medium-6 columns">
            <h2>Your current membership</h2>
            <p>Please select your current membership:</p>
            <div className="buttons">
              {
                types.map((type:any, index:any) => {
                  // if (type.value !== 'jointfamfriend') {
                    return (
                      <button
                        key={index}
                        type="button"
                        className={`md-raised${selectedMembership?.upgrade_from === type.title ? ' active' : '' }`}
                        onClick={() => getSelectedMembership(type.value)}
                      >
                        <span>{type.title}</span>
                      </button>
                    )
                  // } else {
                  //   return null
                  // }
                })
              }
            </div>
            <div className="upgrade_options">
              { selectedMembership &&
                <>
                  <h2>Your upgrade</h2>
                  <p>Please choose an upgrade option:</p>
                </>
              }
              { (selectedMembership?.upgrades) &&
                <div className="radios">
                  <FormControl component="fieldset">
                    <RadioGroup
                      name="upgrade_options"
                      value={upgradeOptions?.to || ''}
                      onChange={props.handleChange}>
                      {
                        selectedMembership.upgrades?.filter((item: any) => !item.with_donation).map((upgrade: any, i: any) => {
                          return (
                            <React.Fragment key={i}>
                              <FormControlLabel
                                key={i}
                                value={upgrade.upgrade_to}
                                checked={
                                  upgradeOptions?.to.replace(' membership plus donation', '') === upgrade.upgrade_to.replace(' membership plus donation', '')
                                }
                                control={<Radio color="secondary" style={{ pointerEvents: 'none' }} />}
                                label={`${upgrade.upgrade_to}: upgrade for £${upgrade.price}`}
                                onClick={() => {
                                  if (!upgrade.topup_donation) {
                                    deleteSS('sameTierTopupDonationAdded')
                                  } else {
                                    deleteSS('manualDonationAdded')
                                    props.setFieldValue('renewal_donation_added', 0)
                                  }
                                  showUpgradeNext(selectedMembership?.title, upgrade.upgrade_to, upgrade.price, upgrade.topup_donation)
                                }} />
                              <p>{upgrade.description}</p>
                            </React.Fragment>
                          )
                        })
                      }
                    </RadioGroup>
                  </FormControl>
                </div>
              }
            </div>
          </div>
          <div className="medium-6 columns">
            <img src="/assets/default/images/membership-upgrade.jpg" alt="Upgrade your Kew membership"/>
          </div>
        </div>
      </div>
      { (upgradeOptions || topupDonation) &&
        <div className="row upgrade-form">
          {!topupDonation &&
            <MembershipPlus topupDonation={topupDonation} {...props} />
          }
          <div className="medium-12 columns">
            <div className="divider"></div>
          </div>
          <div className="row box">
            <div className="medium-6 columns">
              <p>You have selected to upgrade from <strong>{upgradeOptions?.selected} membership</strong> to <strong>{upgradeOptions?.to}{membership_type}</strong> at a cost of <strong>£{upgradeOptions?.price + (topupDonation ? 0 : props.values.renewal_donation_added)}</strong></p>
              <button
                className="btn-cta go"
                id="upgrade-next"
                type="button"
                onClick={(e: any) => {
                  e.preventDefault()
                  setSelectedMembershipModel(selectedMembership)
              }}>Next</button>
            </div>
            <div className="medium-6 columns">
              <NeedHelp />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default UpgradeForm;




